import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useForumSection(id, filters = {}) {
  const { token } = useUser();
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchForumSection() {
      setLoading(true);

      const { response, data } = await API.fetchForumSection(token, id, filters);

      if (response.ok) {
        setResult(data);
        setError(null);
        setLoading(false);
      } else {
        setError(data);
        setResult(null);
        setLoading(false);
      }
    }

    fetchForumSection();
  }, [id, Object.values(filters).join("__")]);

  return {
    loading,
    error,
    threads: result?.threads ?? [],
    section: result?.section ?? null,
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}